import React from 'react'
import { NavbarHome } from '../../components'
import Home from './Home'
import styled from "styled-components";

const HomePage = () => {
  return (
    <>
    <NavbarContainerWrapper>
        <NavbarHome/>
    </NavbarContainerWrapper>

        <Home/>
    </>
  )
}

export default HomePage

export const NavbarContainerWrapper = styled.div`
  padding-top: 60px;
`;